import { render, staticRenderFns } from "./ReminderIndex.vue?vue&type=template&id=615e312a"
import script from "./ReminderIndex.vue?vue&type=script&lang=js"
export * from "./ReminderIndex.vue?vue&type=script&lang=js"
import style0 from "./ReminderIndex.vue?vue&type=style&index=0&id=615e312a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports